// // src/components/common/LogDataDisplay.jsx
// import { formatDateTime } from 'utlis/formateDateTime';
// import React from 'react';

// const LogDataDisplay = ({ logData }) => {
//   // Format the value for display
//   const formatValue = (value) => {
//     if (value === null || value === undefined) return 'None';
//     if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//     if (typeof value === 'string') {
//       // More specific check for datetime strings
//       const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?([+-]\d{2}:\d{2}|Z)?$/;
//       if (isoDateRegex.test(value)) {
//         return formatDateTime(value);
//       }
//     }
//     return String(value);
//   };

//   // Render data fields
//   const renderDataFields = (title, dataObj) => {
//     if (!dataObj || Object.keys(dataObj).length === 0) return null;

//     return (
//       <div className="space-y-3">
//         <p className="text-sm font-medium text-muted-foreground">{title}</p>
//         <div className="bg-muted/50 rounded-lg p-4 space-y-2">
//           {Object.entries(dataObj).map(([key, value]) => {
//             // Skip certain system fields that aren't useful for display
//             if (['id', 'is_deleted', 'deleted_at', 'deleted_by'].includes(key)) return null;

//             // Format the key for display
//             const formattedKey = key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

//             // Format the value for display
//             let displayValue = value;
//             if (value === null || value === undefined) {
//               displayValue = 'None';
//             } else if (typeof value === 'boolean') {
//               displayValue = value ? 'Yes' : 'No';
//             } else if (typeof value === 'string') {
//               // More specific check for datetime strings
//               const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?([+-]\d{2}:\d{2}|Z)?$/;
//               if (isoDateRegex.test(value)) {
//                 displayValue = formatDateTime(value);
//               } else {
//                 displayValue = value;
//               }
//             } else if (typeof value === 'object') {
//               displayValue = JSON.stringify(value, null, 2);
//             }

//             return (
//               <div key={key} className="grid grid-cols-3 gap-4 items-start">
//                 <span className="font-medium text-sm">{formattedKey}</span>
//                 <div className="col-span-2 text-sm break-words">
//                   {typeof displayValue === 'string' && displayValue.includes('\n') ? (
//                     <pre className="whitespace-pre-wrap">{displayValue}</pre>
//                   ) : (
//                     <span>{displayValue}</span>
//                   )}
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   // Render changes
//   const renderChanges = (changes) => {
//     if (!changes || Object.keys(changes).length === 0) return null;

//     return (
//       <div className="space-y-4">
//         <p className="text-sm font-medium text-muted-foreground">Changes Made</p>
//         <div className="bg-muted/50 rounded-lg p-4 space-y-3 text-sm">
//           {Object.entries(changes).map(([field, change]) => {
//             // Format the field name for display
//             const formattedField = field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

//             const oldVal = formatValue(change.old);
//             const newVal = formatValue(change.new);

//             return (
//               <div key={field} className="grid grid-cols-3 gap-4 items-start">
//                 <span className="font-medium">{formattedField}</span>
//                 <div className="text-red-600 break-words">
//                   {oldVal.includes('\n') ? <pre className="whitespace-pre-wrap">{oldVal}</pre> : oldVal}
//                 </div>
//                 <div className="text-green-600 font-medium break-words">
//                   {newVal.includes('\n') ? <pre className="whitespace-pre-wrap">{newVal}</pre> : newVal}
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="space-y-8">
//       {/* Changes */}
//       {renderChanges(logData?.changes)}

//       {/* Old State - Improved Display */}
//       {renderDataFields('Old Data', logData?.old)}

//       {/* New State - Improved Display */}
//       {renderDataFields('New Data', logData?.new)}
//     </div>
//   );
// };

// export default LogDataDisplay;

// src/components/common/LogDataDisplay.jsx
import { formatDateTime } from 'utlis/formateDateTime';
import React from 'react';

const LogDataDisplay = ({ logData }) => {
  // Format the value for display
  const formatValue = (value) => {
    if (value === null || value === undefined) return 'None';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (typeof value === 'string') {
      // More specific check for datetime strings
      const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?([+-]\d{2}:\d{2}|Z)?$/;
      if (isoDateRegex.test(value)) {
        return formatDateTime(value);
      }
    }
    return String(value);
  };

  // Get all unique keys from both old and new data
  const getAllKeys = () => {
    const keys = new Set();

    // Add keys from old data
    if (logData?.old) {
      Object.keys(logData.old).forEach(key => keys.add(key));
    }

    // Add keys from new data
    if (logData?.new) {
      Object.keys(logData.new).forEach(key => keys.add(key));
    }

    // Add keys from changes
    if (logData?.changes) {
      Object.keys(logData.changes).forEach(key => keys.add(key));
    }

    return Array.from(keys).filter(key =>
      !['id', 'is_deleted', 'deleted_at', 'deleted_by'].includes(key)
    );
  };

  // Check if a field has changed
  const hasChanged = (key) => {
    if (!logData?.changes || !logData.changes[key]) return false;
    return true;
  };

  // Get the old value for a field
  const getOldValue = (key) => {
    if (logData?.changes?.[key]?.old !== undefined) {
      return logData.changes[key].old;
    }
    if (logData?.old?.[key] !== undefined) {
      return logData.old[key];
    }
    return null;
  };

  // Get the new value for a field
  const getNewValue = (key) => {
    if (logData?.changes?.[key]?.new !== undefined) {
      return logData.changes[key].new;
    }
    if (logData?.new?.[key] !== undefined) {
      return logData.new[key];
    }
    return null;
  };

  // Render the combined data table
  const renderDataTable = () => {
    const allKeys = getAllKeys();

    if (allKeys.length === 0) return null;

    return (
      <div className="space-y-3">
        <p className="text-sm font-medium text-muted-foreground">Data Changes</p>
        <div className="bg-muted/50 rounded-lg overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-muted/70">
                <th className="text-left p-3 font-medium text-sm">Field</th>
                <th className="text-left p-3 font-medium text-sm">Old Value</th>
                <th className="text-left p-3 font-medium text-sm">New Value</th>
              </tr>
            </thead>
            <tbody>
              {allKeys.map((key) => {
                const formattedKey = key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                const oldValue = getOldValue(key);
                const newValue = getNewValue(key);
                const changed = hasChanged(key);

                const oldDisplayValue = formatValue(oldValue);
                const newDisplayValue = formatValue(newValue);

                return (
                  <tr key={key} className={changed ? "bg-blue-50/50 dark:bg-blue-950/20" : ""}>
                    <td className="p-3 font-medium text-sm">{formattedKey}</td>
                    <td className={`p-3 text-sm ${changed ? "text-red-600" : ""}`}>
                      {typeof oldDisplayValue === 'string' && oldDisplayValue.includes('\n') ? (
                        <pre className="whitespace-pre-wrap text-xs">{oldDisplayValue}</pre>
                      ) : (
                        <span>{oldDisplayValue}</span>
                      )}
                    </td>
                    <td className={`p-3 text-sm ${changed ? "text-green-600 font-medium" : ""}`}>
                      {typeof newDisplayValue === 'string' && newDisplayValue.includes('\n') ? (
                        <pre className="whitespace-pre-wrap text-xs">{newDisplayValue}</pre>
                      ) : (
                        <span>{newDisplayValue}</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-8">
      {/* Combined Data Table */}
      {renderDataTable()}
    </div>
  );
};

export default LogDataDisplay;